module.exports = __webpack_public_path__ + "static/img/5.890c5b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/hospital/5.png
// module id = eTqg
// module chunks = 1